<template>
	<v-card class="banner elevation-0" v-bind:style="{ marginTop: `${mt}px` }">
		<a
			v-if="
				banner.banner_click_url &&
				banner.banner_click_url !== 'https://clowder.com/banner-without-link'
			"
			:href="banner.banner_click_url"
			target="_blank"
		>
			<img
				:src="banner.banner_content"
				alt="banner image"
				class="banner-image"
				v-bind:style="{ borderRadius: imageBorderRadius }"
			/>
		</a>
		<img
			v-else
			:src="banner.banner_content"
			alt="banner image"
			class="banner-image"
			v-bind:style="{ borderRadius: imageBorderRadius }"
		/>
		<div class="banner__content pa-4 mb-2" v-if="isTitleVisible || isDescriptionVisible">
			<v-card-title v-if="isTitleVisible" class="banner-title pa-0">
				{{ banner.banner_title }}
			</v-card-title>
			<v-card-text
				v-if="isDescriptionVisible"
				class="banner-text pt-2"
			>
				{{ banner.banner_description }}
			</v-card-text>
		</div>
	</v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
	props: {
		banner: {
			type: Object,
			default: () => {},
		},
		mt: {
			type: Number,
			default: 0,
		},
	},
	methods: {
		...mapActions('advertisement', ['recordBannerView']),
	},
	computed: {
		isTitleVisible() {
			return this.banner.banner_type === 2 && this.banner.banner_title
		},
		isDescriptionVisible() {
			return this.banner.banner_type !== 4 && this.banner.banner_description
		},
		imageBorderRadius() {
			if (
				this.banner.banner_type === 4 ||
				(!this.isTitleVisible && !this.isDescriptionVisible)
			) {
				return '10px'
			} else {
				return '10px 10px 0 0'
			}
		},
	},
	mounted() {
		this.banner.banner_view_url && this.recordBannerView(this.banner.banner_view_url)
	},
}
</script>
<style lang="scss">
.banner {
	max-width: 555px;
	width: 100%;
	line-height: 0;
	border-radius: 8px !important;
	font-family: Inter, sans-serif;
	&__content {
		border-width: 0 1px 1px 1px;
		border-style: solid;
		border-color: #e2e2e2;
	}

	&-image {
		width: 100%;
	}

	&-title {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--accent-color);
	}

	&-text {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}
}
</style>
